/* @flow weak */
import ConnectedBankAccounts from 'collections/ConnectedBankAccounts';
import { ActionTypes as BankAccountActionTypes } from '../constants/ConnectedBankAccountConstants';

export const initialState = {
  connectedBankAccounts: new ConnectedBankAccounts(),
};

export function reducer(state = initialState, action) {
  let connectedBankAccounts;

  switch (action.type) {
    case BankAccountActionTypes.REJECT:
      connectedBankAccounts = state.connectedBankAccounts.clone();
      connectedBankAccounts.remove(action.connectedBankAccountUUID);
      return { ...state, connectedBankAccounts };

    case BankAccountActionTypes.LOAD_CONNECTED_BANK_ACCOUNTS:
      connectedBankAccounts = state.connectedBankAccounts.clone();
      connectedBankAccounts.add(action.connectedBankAccounts.models);
      return { ...state, connectedBankAccounts };

    case BankAccountActionTypes.REVOKE_ACCESS:
    case BankAccountActionTypes.APPROVE:
    case BankAccountActionTypes.GET_CONNECTED_BANK_ACCOUNT:
    case BankAccountActionTypes.CREATE_CONNECTED_BANK_ACCOUNT: {
      const updatedConnectedBankAccounts = state.connectedBankAccounts.clone();
      updatedConnectedBankAccounts.add(action.connectedBankAccount);
      return { ...state, connectedBankAccounts: updatedConnectedBankAccounts };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/ConnectedBankAccounts.js